<template>
<div class="fff">
  <div class="page_title">{{$t('twoFactor.title1')}}</div>
  <div class="Take">
    {{$t('twoFactor.title2')}}
  </div>
  <!-- <div class="Take c0080FF">
  Here’s how to turn off two-factor authentication on iOS devices.
  </div> -->
  <div class="twoButton">
    <div @click="$router.go(-1)" class="BackButton">{{$t('twoFactor.title3')}}</div>
    <div @click="$router.push({path: '/Allow'})" class="loginButton">{{$t('twoFactor.title4')}}</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.Take{font-size:14px;color:grey;line-height:20px;margin-left:5%;width:85%;max-width:800px}
.c0080FF{margin-top:40px;color:#0080ff}

</style>



// WEBPACK FOOTER //
// src/components/TwoFactor.vue